import { Injectable } from '@angular/core';
import { RestService } from "app/webservice/rest.service";
import { Http } from "@angular/http";
import { environment } from "environments/environment";
import { BehaviorSubject } from "rxjs/Rx";

@Injectable()
export class MediaService {

  public selectedAsset = new BehaviorSubject<any>({});

  constructor(
    private _http: Http, 
    private _restService: RestService
  ) { }
  
}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/media/media.service.ts